import React from 'react'

const LoaderCircle = (props) => {
  return(
    <div className='loader m-auto' />
  )
}

export default LoaderCircle
